<template>
  <div class="app">
    <!-- Page Wrapper -->
    <div id="wrapper">
      <!-- Sidebar -->

      <ul
        class="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion"
        id="accordionSidebar"
      >
        <!-- Sidebar - Brand -->
        <a
          class="sidebar-brand d-flex align-items-center justify-content-center log-height"
          href="#"
        >
          <div class="sidebar-brand-icon rotate-n-15">
            <img src="../containers/LOGO.png" width="50px" alt="logo"/>
          </div>

          <div
            class="sidebar-brand-text mx-3 font-size: small logo-txt-div"
          >
            <strong class="logo-margin">Brain100 studio</strong>
          </div>
        </a>
        <div :key="menu" v-for="(menu, index) in menuList">
          <!-- Divider -->
          <hr class="sidebar-divider my-0" v-if="menu.type == 'header'" />
          <!-- Nav Item - Dashboard -->
          <li :class="menu.type == 'header' ? 'nav-item active' : 'nav-item'">
            <a
              class="nav-link"
              :href="'#' + menu.url"
              v-if="menu.type == 'header'"
            >
              <em class="fas fa-fw fa-tachometer-alt" ></em>
              <span>{{ menu.name }}</span>
            </a>
            <a
              v-if="menu.type == 'menu'"
              class="nav-link collapsed"
              :href="'#' + menu.url"
              :data-toggle="menu.submenu.length > 0 ? 'collapse' : ''"
              :data-target="'#' + menu.datatarget"
              :id="'ref' + menu.datatarget"
              aria-expanded
              :aria-controls="menu.datatarget"
            >
              <em :class="menu.icon" ></em>
              <span> {{ menu.name }}</span>
            </a>
            <div
              :id="menu.datatarget"
              class="collapse"
              aria-labelledby="headingTwo"
              data-parent="#accordionSidebar"
              v-if="menu.submenu.length > 0"
            >
              <div class="bg-white py-2 collapse-inner rounded">
                <a
                  v-for="(subM) in menu.submenu"
                  :id="subM.menuName"
                  :key="subM"
                  class="collapse-item custom-padding"
                  :href="'#' + subM.url"
                  >{{ subM.name }}</a
                >

              </div>
            </div>
          </li>
          <!-- Divider -->
          <hr class="sidebar-divider my-0" v-if="menu.type == 'header'" />
          <!-- Divider -->
          <hr class="sidebar-divider" v-if="menuList.length == index + 1" />

          <!-- Sidebar Toggler (Sidebar) -->
          <div
            class="text-center d-none d-md-inline"
            v-if="menuList.length == index + 1"
          >
            <button class="rounded-circle border-0" id="sidebarToggle"></button>
          </div>
        </div>
        <p
          class="copyright text-left my-auto sticky-footer bg-blue version-style"
        >
          Ver 1.1.2
        </p>
      </ul>

      <!-- End of Sidebar -->

      <!-- Content Wrapper -->
      <div id="content-wrapper" class="d-flex flex-column">
        <!-- Main Content -->
        <div id="content" class="bg-color">
          <!-- Topbar -->
          <nav
            class="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow log-height"
          >
            <!-- Sidebar Toggle (Topbar) -->
            <button
              id="sidebarToggleTop"
              class="btn btn-link d-md-none rounded-circle mr-3"
            >
              <em class="fa fa-bars"></em>
            </button>
            <img
              v-if="!(roleName == '3' || roleName == '4' || roleName == '7')"
              src="../containers/mig-2.png"
              width="50px"
              alt="logo"
            />
            <a
              v-else
              class="navbar-brand "
              role="button"
            >
              <span class="mr-2  d-lg-inline text-gray-600 small">{{
                partnerName
              }}</span>
            </a>

            <!-- Topbar Navbar -->
            <ul class="navbar-nav ml-auto">

              <!-- Nav Item - Search Dropdown (Visible Only XS) -->

              <!-- Nav Item - Alerts -->
              <!-- Nav Item - Alerts -->
              <li
                class="nav-item no-arrow mx-1"
                v-if="checkPermisssionRole('NOTIFICATION_PARTNER', false, 'read')"
              >
                <a class="nav-link" href="#/partnernotification">
                  <em class="fas fa-bell fa-fw bell-icon"></em>
                  <!-- Counter - Alerts -->
                  <span
                    class="badge badge-danger badge-counter"
                    v-if="notificationCount.unread_count"
                    >{{ notificationCount.unread_count }}</span
                  >
                </a>
              </li>

              <!-- Nav Item - User Information -->
              <li class="nav-item dropdown no-arrow">
                <a
                  class="navbar-brand dropdown-toggle"
                  href="#"
                  id="userDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  :style="
                   (roleName == '3' || roleName == '4' || roleName == '7')
                      ? 'padding-top:15px'
                      : ''
                  "
                >
                  <!-- below line will not show in mobile if you add "d-none" class -->
                  <span class="mr-2  d-lg-inline text-gray-600 small">{{
                    this.userprofile
                  }}</span>
                </a>
                <!-- Dropdown - User Information -->
                <div
                  class="dropdown-menu dropdown-menu-right shadow animated--grow-in"
                  aria-labelledby="userDropdown"
                >
                  <a class="dropdown-item" href="#/profile">
                    <em class="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></em>
                    {{ $t("PROFILE") }}
                  </a>

                  <div class="dropdown-divider"></div>

                  <a class="dropdown-item" href="#/changepasscode">
                    <em
                      class="fas fa fa-key fa-sm fa-fw mr-2 text-gray-400"
                    ></em>
                    {{ $t("CHANGEPASSWORD") }}
                  </a>
                  <div class="dropdown-divider"></div>
                  <a class="dropdown-item" href="#" @click="logout()">
                    <em
                      class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"
                    ></em>
                    {{ $t("LOGOUT") }}
                  </a>
                </div>
              </li>
            </ul>
          </nav>
          <!-- End of Topbar -->

          <!-- Begin Page Content -->
          <div class="container-fluid">
            <!-- Page Heading -->
            <router-view></router-view>
          </div>
          <!-- /.container-fluid -->
        </div>
        <!-- End of Main Content -->

        <!-- Footer -->
        <footer class="sticky-footer bg-white">
          <div class="container my-auto">
            <div class="copyright text-center my-auto">
              <span>
                Copyright ©
                <a href="http://brain100studio.com/" target="_blank" rel="noopener noreferrer"
                  >Brain100 studio</a
                >
                2020
              </span>
            </div>
          </div>
        </footer>
        <!-- End of Footer -->
      </div>
      <!-- End of Content Wrapper -->
    </div>
    <!-- End of Page Wrapper -->

    <!-- Scroll to Top Button-->


    <!-- Logout Modal-->
    <div
      class="modal fade"
      id="logoutModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Ready to Leave?</h5>
            <button
              class="close"
              type="button"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            Select "Logout" below if you are ready to end your current session.
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-secondary"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <a class="btn btn-primary" href="#/login">Logout</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import nav from "@/_nav";
import i18n from "@/plugins/i18n";
import { LOGOUT } from "@/store/actions.type";
import store from "./../store/index.js";
import * as get from "lodash";
import { filters } from "./../filters/common";
import { mapGetters } from "vuex";
import { checkPermisssion, checkPermisssionRole } from "@/shared/utils.js";
export default {
  name: "RootContainer",
  components: {},
  data() {
    return {
      checkPermisssion: checkPermisssion,
      checkPermisssionRole: checkPermisssionRole,
      authStore: store.state.auth,
      roleName: store.state.auth.roleName,
      partnerName: store.state.auth.partnerName,
      nav: nav.items,
      userprofile: {},
      languages: [
        { flag: "us", language: "en", title: "EN" },
        { flag: "jp", language: "ja", title: "JA" }
      ],
      role: "",
      MIG: filters.menuList,
      timeOutFunction:""
    };
  },
  computed: {
    name() {
      return this.$route.name;
    },
    ...mapGetters(["notificationCount"])
  },
mounted: function () {
  let myTimer = () => {
      if("Login" != this.$route.name && localStorage.getItem("expires_in") != null){

      clearInterval(this.timeOutFunction);
         this.logout();
      }
  }
   this.timeOutFunction = setInterval(myTimer, (Number(localStorage.getItem("expires_in")) -  Number(new Date().getTime())) );
},
  methods: {
    changeLocale(locale) {
      i18n.locale = locale;
    },
    logout() {
      clearInterval(this.timeOutFunction);
      this.$store.dispatch(LOGOUT, {}).then(data => {
        this.$router.push("/login");
      });
    },

  },
  created() {
    this.$toast.removeAll();
    this.userprofile = localStorage.userid;
    this.role = localStorage.getItem("role");
    let permissions = get.filter(
      this.authStore.permissions,
      item => item.hide !== 1
    );
    let menuListTest = [];
    get.map(this.MIG, menu => {
      let findMenu = get.filter(
        permissions,
        access => access.module == menu.module
      );
      let submenuList = [];
      if (findMenu && findMenu.length) {
        get.map(menu.submenu, subMneu => {
          let findSubMenu = get.filter(
            findMenu[0].submenu,
            sb => sb.module == subMneu.module
          );

          if (findSubMenu && findSubMenu.length) {
            submenuList.push(subMneu);
          }
        });
        if (findMenu[0].submenu.length == 0) {
          menuListTest.push(menu);
        }
      }
      if (submenuList.length) {
        menu.submenu = submenuList;
        menuListTest.push(menu);
      }
    });

    this.menuList = menuListTest;
  }
};
</script>
<style scoped lang="scss">
.flag-button {
  margin: 3px;
}
.iconFont {
  font-size: 24px;
}
.custom-padding{
  padding: .5rem 0.5rem !important;
}
.bg-color{
  background:#fff;
}
.log-height{
  height: 3.375rem;
}
.logo-txt-div{
  margin-left: -1rem!important;text-transform: none !important;
}
.logo-margin{
  margin-left:20px
}
.version-style{
  color:#fff;position: absolute;
    bottom: 5px;
    margin-left: 12px;
    text-align: center;
}
.bell-icon{
  font-size: 20px;
}
</style>
